export default "__VITE_ASSET__DQsBgT9E__"